import React from 'react';
import { Form, Slider } from 'antd';
import { I18n } from '@aws-amplify/core';
import { frequencyValues, frequencyMarks } from '@/components/views/Report/KimLhc/Constants';

interface MovementFrequencyFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

const getFrequencyValueFromSlider = (sliderIndex: number): number => {
	return frequencyValues[sliderIndex];
};

const getSliderIndexFromFrequency = (frequencyValue: number) => ({
	value: frequencyValues.indexOf(frequencyValue)
});

export function MovementFrequencyFormItem({
	required = false,
	fieldName
}: Readonly<MovementFrequencyFormItemProps>): JSX.Element {
	return (
		<Form.Item
			name={fieldName}
			rules={[{ required, message: I18n.get('The field requires an answer') }]}
			getValueFromEvent={getFrequencyValueFromSlider}
			getValueProps={getSliderIndexFromFrequency}
		>
			<Slider marks={frequencyMarks} tooltip={{ open: false }} min={0} max={12} step={1} />
		</Form.Item>
	);
}
